import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { fetchOngageUnsubscribeRequest } from './OngageUnsubscribeSlice'
import {
  getAccessToken,
  selectCampaigns,
  selectLoadingList,
  selectObfuscatedEmail,
  selectErrorList
} from './OngageUnsubscribeSelector'

import { ErrorComponent, Layout } from './components'
import Spinner from 'src/lib/ui/Spinner'

const Initializer = ({ children }) => {
  const dispatch = useDispatch()
  const loading = useSelector(selectLoadingList)
  const error = useSelector(selectErrorList)
  const accessToken = useSelector(getAccessToken)
  const obfuscatedEmail = useSelector(selectObfuscatedEmail)
  const campaigns = useSelector(selectCampaigns)

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search)
    const memberId = queryParams.get('MemberID')
    const emailId = queryParams.get('EmailID')

    dispatch(
      fetchOngageUnsubscribeRequest({
        partyId: memberId,
        partyEmailId: emailId
      })
    )
  }, [dispatch])

  if (loading) {
    return <Spinner fillColor="transparent" strokeColor="rgba(213,213,213,1)" />
  }

  if (error) {
    return (
      <Layout>
        <ErrorComponent />
      </Layout>
    )
  }

  if (!accessToken || !obfuscatedEmail || !campaigns) {
    return <Spinner fillColor="transparent" strokeColor="rgba(213,213,213,1)" />
  }

  return <>{children}</>
}

export default Initializer
